import {Text} from '@mantine/core';
import {DataTableColumn} from 'mantine-datatable';
import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {MeteringRecord} from '../types';

// Every column is sortable (MODULE_COMPLIANCE_CHECKLIST §3a). The accessor is
// what useTableSort sorts by; render only controls how the cell looks.
export const useMeteringRecordsTableColumns = (onRecordClick: (record: MeteringRecord) => void): DataTableColumn<MeteringRecord>[] => [
    {
        accessor: 'productCode',
        title: I18n.get('Product Code'),
        sortable: true,
        render: (item) => (
            <Text
                c="blue"
                style={{cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.productCode}
            </Text>
        ),
    },
    {
        accessor: 'created',
        title: I18n.get('Created'),
        sortable: true,
        render: (item) => formatTimestamp(item.created),
    },
];
